import { Component, Host, h, State, Watch, Listen, Prop, Element } from '@stencil/core';

@Component({
  tag: 'epic-wait-times',
  styleUrl: 'epic-wait-times.scss',
  shadow: true,
})
export class EpicWaitTimes {

  @Prop() clinic_id : string;
  @Prop() clinic_type : string;
  @Prop() clinic_title: string;
  @Element() private element: HTMLElement;

  @State() waittime: string = null;

  componentDidLoad() {
      //this.startWaitTime(this.clinic_id);
      if (this.clinic_id !== "0" && this.clinic_id !== "")
      this.startWaitTime(this.clinic_id);
  }

  componentDidRender() {
    
  }

  startWaitTime(clinic_id) {
		
		if (clinic_id == "" || clinic_id == "0") return;
    
		this.updateWaitTime(clinic_id);

		setTimeout(() => {
			this.updateWaitTime(clinic_id);
		}, 60000);
	}

	updateWaitTime(clinic_id) {
    console.log("WaitTime", this.clinic_title, clinic_id, this.clinic_type);
		var api = `/restapi/locations/${clinic_id}/${this.clinic_type}/waittime`;
		fetch(api,{
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'none'
      }
    }).then(response => response.json()).then(data => {
      if (data.WaitTimeInMinutes >= 0) {
        this.waittime = data.WaitTimeInMinutes + " Minutes";  
      } else {
        this.waittime = "No wait time provided"
        //this.element.style.display = "none";
      }
		}).catch(exc => {
      this.element.style.display = "none";
    });
  }

    
  render() {
      return (
          <Host>
              <div class="epic-waittime" part="epic-waittime">
                  <div>
                        {this.clinic_type == "EDWait" && (
                          <div><span>E</span>mergency <span>C</span>are</div>
                        )}
                        {this.clinic_type == "ImmediateCareWait" && (
                          <div><span><span>U</span>rgent <span>C</span>are</span></div>
                        )}
                  </div>
                  <div>
                      <div class="title">Wait Time</div>
                      <div class="current-wait">Current wait is: {this.waittime}</div>
                      {/* <div class="link">
                          <a href={`https://www.clockwisemd.com/hospitals/${this.clinic_id}/visits/new`} target="_blank">
                              <span>Reserve my spot</span>
                              <icon-arrow />
                          </a>
                      </div> */}
                  </div>
              </div>
          </Host>
      )

  }

}
